export default "__VITE_ASSET__25vGfBLR__"